import { render, staticRenderFns } from "./AuditRiskDetails.vue?vue&type=template&id=68383fb8&scoped=true&"
import script from "./AuditRiskDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./AuditRiskDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AuditRiskDetails.vue?vue&type=style&index=0&id=68383fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68383fb8",
  null
  
)

export default component.exports